export default __webpack_public_path__ + "static/media/gacertificate1609095570.ae2f3c39.pdf";